import {IndividualAnalysisRequest} from 'api/analysisApi'
import {
  closeIcaConfirmDialog,
  closeIcaResultDialog,
  closeIcaSelectDialog,
  confirmIcaConfirmDialog,
  confirmIcaResultDialog,
  confirmIcaSelectDialog,
  openIcaSelectDialog,
  selectIcaConfirmOpen,
  selectIcaResultOpen,
  selectIcaSelectOpen,
  selectIndividualId,
  selectReAnalysisYn,
} from 'features/analysis/eegIndividualSlice'
import {useAppDispatch, useAppSelector} from 'hooks'

export function useIcaSelectDialog() {
  const dispatch = useAppDispatch()

  const isOpen = useAppSelector(selectIcaSelectOpen)

  const onOpen = (payload: number) => dispatch(openIcaSelectDialog(payload))

  const onConfirm = (payload: IndividualAnalysisRequest) =>
    dispatch(confirmIcaSelectDialog(payload))

  const onClose = () => dispatch(closeIcaSelectDialog())

  return {
    open: isOpen,
    onOpen,
    onConfirm,
    onClose,
  }
}

export function useIcaConfirmDialog() {
  const dispatch = useAppDispatch()

  const isOpen = useAppSelector(selectIcaConfirmOpen)
  const individualId = useAppSelector(selectIndividualId)

  const onConfirm = () => dispatch(confirmIcaConfirmDialog())

  const onClose = () => dispatch(closeIcaConfirmDialog())

  return {
    open: isOpen,
    individualId,
    onConfirm,
    onClose,
  }
}

export function useIcaResultDialog() {
  const dispatch = useAppDispatch()

  const isOpen = useAppSelector(selectIcaResultOpen)
  const individualId = useAppSelector(selectIndividualId)
  const reAnalysisYn = useAppSelector(selectReAnalysisYn)

  const onConfirm = () => dispatch(confirmIcaResultDialog())

  const onClose = () => dispatch(closeIcaResultDialog())

  return {
    open: isOpen,
    individualId,
    ReAnalysis: reAnalysisYn,
    onConfirm,
    onClose,
  }
}
